import { Component } from "@angular/core";

@Component({
  selector: "app-icon-check-circle",
  standalone: true,
  imports: [],
  templateUrl: "./check-circle.component.html",
})
export class CheckCircleIconComponent {}
